import { merge } from 'lodash';
import Card from './Card';
import Lists from './Lists';
import Paper from './Paper';
import Input from './Input';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import IconButton from './IconButton';
import Autocomplete from './Autocomplete';
import DataGrid from './DataGrid';
import Chip from './Chip';
import Icon from './Icon';

export default function ComponentsOverrides(theme) {
    return merge(
        Card(theme),
        Lists(theme),
        Paper(theme),
        Input(theme),
        Button(theme),
        Tooltip(theme),
        Backdrop(theme),
        Typography(theme),
        IconButton(theme),
        Autocomplete(theme),
        DataGrid(theme),
        Chip(theme),
        Icon(theme)
    );
}
